import AbstractDropdownView from './AbstractDropdownView';

export default AbstractDropdownView;
